export const checkIfMobile = () => {
  const mobileBreakpoint = 1080;
  return window.innerWidth <= mobileBreakpoint;
};